import { styled } from 'styled-components';

import { createResponsiveGeneralStyle, createResponsiveSpacingStyle, getColor } from '../../../utils';
import { Spacer } from '../Spacer';
import type { ContainerProps } from './types';

const Wrapper = styled(Spacer)<ContainerProps>`
  ${props => props.position && createResponsiveGeneralStyle('position', props.position)};
  ${props => props.overflowY && createResponsiveGeneralStyle('overflow-y', props.overflowY)};
  ${props => props.overflowX && createResponsiveGeneralStyle('overflow-X', props.overflowX)};
  ${props => props.background && createResponsiveGeneralStyle('background', props.background)};
  ${props => props.backgroundColor && `background-color: ${getColor(props.backgroundColor)}`};
  ${props => props.boxSizing && createResponsiveGeneralStyle('box-sizing', props.boxSizing)};
  ${props => props.flexGrow !== undefined && createResponsiveGeneralStyle('flex-grow', props.flexGrow)};
  ${props => props.flexShrink !== undefined && createResponsiveGeneralStyle('flex-shrink', props.flexShrink)};
  ${props => props.flexBasis !== undefined && createResponsiveSpacingStyle('flex-basis', props.flexBasis)};
  ${props => props.textAlign && createResponsiveGeneralStyle('text-align', props.textAlign)};
  ${props => props.maxWidth && createResponsiveSpacingStyle('max-width', props.maxWidth)};
  ${props => props.minWidth && createResponsiveSpacingStyle('min-width', props.minWidth)};
  ${props => props.width && createResponsiveSpacingStyle('width', props.width)};
  ${props => props.height && createResponsiveSpacingStyle('height', props.height)};
  ${props => props.maxHeight && createResponsiveSpacingStyle('max-height', props.maxHeight)};
  ${props => props.minHeight && createResponsiveSpacingStyle('min-height', props.minHeight)};
  ${props => props.paddingTop && createResponsiveSpacingStyle('padding-top', props.paddingTop)};
  ${props => props.paddingRight && createResponsiveSpacingStyle('padding-right', props.paddingRight)};
  ${props => props.paddingBottom && createResponsiveSpacingStyle('padding-bottom', props.paddingBottom)};
  ${props => props.paddingLeft && createResponsiveSpacingStyle('padding-left', props.paddingLeft)};
  ${props => props.border !== undefined && createResponsiveGeneralStyle('border', props.border)};
  ${props => props.borderRadius !== undefined && createResponsiveGeneralStyle('border-radius', props.borderRadius)};
  ${props => props.boxShadow !== undefined && createResponsiveGeneralStyle('box-shadow', props.boxShadow)};
`;

export const Container = ({
  id,
  style,
  className,
  position,
  boxSizing = 'border-box',
  flexGrow,
  flexShrink,
  flexBasis,
  width,
  minWidth,
  maxWidth,
  height,
  minHeight,
  maxHeight,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  background,
  backgroundColor,
  textAlign,
  name,
  initial,
  animate,
  variants,
  exit,
  transition,
  border,
  borderRadius,
  boxShadow,
  role,
  children,
  overflowY,
  overflowX,
}: ContainerProps) => (
  <Wrapper
    style={style}
    overflowY={overflowY}
    overflowX={overflowX}
    className={className}
    position={position}
    boxSizing={boxSizing}
    flexGrow={flexGrow}
    flexShrink={flexShrink}
    flexBasis={flexBasis}
    width={width}
    minWidth={minWidth}
    maxWidth={maxWidth}
    height={height}
    minHeight={minHeight}
    maxHeight={maxHeight}
    marginTop={marginTop}
    marginRight={marginRight}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    paddingTop={paddingTop}
    paddingRight={paddingRight}
    paddingBottom={paddingBottom}
    paddingLeft={paddingLeft}
    background={background}
    backgroundColor={backgroundColor}
    textAlign={textAlign}
    name={name}
    initial={initial}
    animate={animate}
    variants={variants}
    exit={exit}
    transition={transition}
    border={border}
    borderRadius={borderRadius}
    boxShadow={boxShadow}
    role={role}
    id={id}
  >
    {children}
  </Wrapper>
);
